export default {
  "months": {
    "long": [
      "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
      "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
    ],
    "short": [
      "янв.", "фев.", "мар.", "апр.", "мая", "июн.",
      "июл.", "авг.", "сен.", "окт.", "ноя.", "дек."
    ]
  },
  "weekdays": {
    "long": [
      "Понедельник", "Вторник", "Среда",
      "Четверг", "Пятница", "Суббота", "Воскресенье"
    ],
    "short": [
      "пн", "вт", "ср", "чт", "пт", "сб", "вс"
    ]
  },
  "buttons": {
    "today": "Сегодня",
    "cancel": "Отмена",
    "select": "Выбрать"
  }
};
